<form #formCliente="ngForm" id="formCliente">
  <div class="row">
    <div class="form-group" *ngIf="isAgentePesadosBr">
      <span class="icon residencial"></span>
      <div class="inputs">
        <label for="cep">CEP do Cliente</label>
        <input
          class="form-control"
          type="text"
          placeholder="00000-000"
          mask-number
          [mask]="'00000-000'"
          [minLength]="8"
          [maxLength]="9"
          required
          appShowErrorMessages
          requiredMessage="O campo CEP é obrigatório"
          name="cep"
          appOnlyNumberRestrictive
          appOnlyDigitsLengthValidator
          (blur)="onCepExit()"
          [(ngModel)]="cepAgente"
        />
        <a
          class="font-orange"
          title="Consultar site dos correios"
          target="_blank"
          (click)="onClickFindCep()"
          >Não sabe o CEP?</a
        >
        <div class="info-cep" *ngIf="agenteEndereco">
          <span class="small-icon icon_info"></span>
          <div>
            <h5 class="font-orange">
              Essa proposta será enviada para o Agente:
            </h5>
            <h5>
              {{ agenteEndereco?.code }} - {{ agenteEndereco?.name }} -
              {{ agenteEndereco?.address?.city }},
              {{ agenteEndereco?.address?.state }}
            </h5>
          </div>
        </div>
        <div class="info-cep" *ngIf="cepErrorStatus === 404">
          <span class="small-icon icon_error"></span>
          <div>
            <h5 class="font-red">
              CEP indisponível! Não será possível atender um cliente dessa
              região
            </h5>
            <h5>
              Cidade: {{ endereco?.cidade }} | Estado:
              {{ endereco?.uf }}
            </h5>
          </div>
        </div>
        <div *ngIf="cepErroMessage" class="info-cep">
          <span class="small-icon icon_info_error"></span>
          <div>
            <h5 class="font-red">
              <span class="msg-color-error">
                Digite um CEP válido para realizar a consulta
              </span>
            </h5>
          </div>
        </div>
        <app-loader-default
          text="Buscando CEP"
          [show]="isBuscandoCep"
          size="fa-1x"
        ></app-loader-default>
      </div>
    </div>
    <div class="form-group">
      <span class="icon id-number"></span>
      <div class="inputs">
        <label for="cpf-clientef">CPF</label>
        <input
          name="cpf-cliente"
          type="text"
          class="form-control"
          [(ngModel)]="fichaCadastro._client.cpf"
          [disabled]="isValidatingClienteCpf"
          mask-number
          [mask]="'000.000.000-00'"
          placeholder="Digite apenas numeros"
          appCpfValidator
          required
          appShowErrorMessages
          requiredMessage="O Campo CPF é obrigatório"
          (blur)="getCpfCliente()"
          #cpfCliente="ngModel"
        />

        <div *ngIf="isValidatingClienteCpf">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Verificando CPF do Cliente...
        </div>
      </div>
    </div>
    <div class="form-group">
      <span class="icon aniversario"></span>
      <div class="inputs">
        <label for="data-nascimento-cliente">Data de Nascimento</label>
        <input
          #dataNascimento
          name="data-nascimento-cliente"
          type="text"
          [(ngModel)]="fichaCadastro._client.dataNascimento"
          [disabled]="isValidatingClienteCpf"
          mask-number
          [mask]="'00/00/0000'"
          dropSpecialCharacters="true"
          [dropSpecialCharacters]="true"
          placeholder="00/00/0000"
          class="form-control"
          appDataValidator
          [dateRange]="dataRange"
          required
          appShowErrorMessages
          appOnlyDigits
        />
      </div>
    </div>
    <div class="form-group">
      <span class="icon mobile"></span>
      <div class="inputs">
        <label for="celular-cliente">Celular do cliente</label>
        <input
          name="celular-cliente"
          type="tel"
          [(ngModel)]="fichaCadastro._client.telefones.celular"
          [disabled]="isValidatingClienteCpf"
          required
          appShowErrorMessages
          appOnlyDigitsLengthValidator
          [minLength]="11"
          [maxLength]="15"
          class="form-control"
          placeholder="(00) 00000-0000"
          appTelefone
          #celularCliente="ngModel"
          genericErrorMessage
          appCelularValidator
          (focus)="clearErrorMessage()"
          [ngModelOptions]="{ updateOn: 'blur' }"
        />
        <div *ngIf="errorMessage" class="text-danger">
          {{ errorMessage }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <span class="icon income"></span>
      <div class="inputs">
        <label for="cliente-renda-comprovada">Renda Comprovada</label>
        <input
          name="cliente-renda-comprovada"
          type="text"
          class="form-control"
          placeholder="Digite apenas números"
          [maxLength]="15"
          required
          [disabled]="isValidatingClienteCpf"
          [(ngModel)]="fichaCadastro._client.renda"
          [prefix]="'R$'"
          mask-money
          appOnlyMoney
          appRendaValidator
          [valorMaximo]="this.fichaCadastro?.limiteRenda?.rendaMaxima"
          [valorMinimo]="this.fichaCadastro?.limiteRenda?.rendaMinima"
          (ngModelChange)="fichaCadastro._client.renda = $event"
          appOnlyDigitsLengthValidator
          appShowErrorMessages
        />

        <div
          class="switch-group"
          [ngClass]="{ 'switch-group__pesados': isPesados }"
          *ngIf="isPesados"
        >
          <app-switch
            id="future-income"
            name="cliente-renda-futura"
            [(ngModel)]="fichaCadastro._client.rendaFutura"
          >
          </app-switch>
          <span>Renda futura ou estimada</span>
        </div>
      </div>
    </div>

    <div
      class="form-group"
      *ngIf="isPesados && !fichaCadastro._client.rendaFutura"
    >
      <span class="icon"></span>

      <div class="inputs field-group__pesados">
        <label for="user-married">Como o cliente comprova a renda?</label>

        <app-multiple-select
          *ngIf="!loadingComprovanteRenda"
          name="cliente-comprova-renda"
          [data]="multipleSelectData"
          [(ngModel)]="fichaCadastro._client.tipoComprovanteRenda"
          [options]="comprovanteRendaOptions"
          [width]="390"
          [placeholder]="'Selecione uma ou mais opções...'"
          (valueChanged)="onChangeTipoComprovanteRenda($event)"
          [required]="!fichaCadastro._client.rendaFutura"
        >
        </app-multiple-select>
        <div
          class="text-danger"
          *ngIf="!tipoComprovanteRendaValid && tipoComprovanteRendaTouched"
        >
          Campo Obrigatório
        </div>

        <input
          id="outroComprovanteRenda"
          *ngIf="showOutroComprovanteRenda"
          type="text"
          autocomplete="off"
          class="form-control field-group__outro-comprovante"
          name="cliente-outro-comprovante"
          [(ngModel)]="fichaCadastro._client.outroComprovanteRenda"
          placeholder="Digite aqui o tipo do comprovante de renda"
          minlength="1"
          maxlength="30"
          [required]="showOutroComprovanteRenda"
          [charOnly]="true"
          uppercase
          (blur)="onBlurOutroComprovanteRenda()"
        />
        <div
          class="text-danger"
          *ngIf="
            showOutroComprovanteRenda &&
            (fichaCadastro._client.outroComprovanteRenda === '' ||
              fichaCadastro._client.outroComprovanteRenda === null) &&
            outroComprovanteRendaTouched
          "
        >
          Campo Obrigatório
        </div>
      </div>
    </div>

    <div class="form-group row bg-white border-bottom">
      <span class="icon"></span>

      <div class="switch-row">
        <div class="switch-group">
          <app-switch
            id="user-guarantor"
            name="q1"
            (change)="onClickAvalista()"
            [(ngModel)]="fichaCadastro.isAvalista"
            [disabled]="isValidatingClienteCpf"
          >
          </app-switch>
          <span class="radio-label">Adicionar Avalista</span>
        </div>

        <div class="switch-group switch-field" *ngIf="isPesados">
          <app-switch
            id="user-spouse"
            name="conjuge"
            (change)="onClickConjuge()"
            [(ngModel)]="fichaCadastro.isConjuge"
            [disabled]="isValidatingClienteCpf || hasAvalistaConjuge"
          >
          </app-switch>
          <span class="radio-label">Adicionar Cônjuge</span>
        </div>
      </div>
    </div>
  </div>
</form>

<app-dados-avalista
  [hidden]="!fichaCadastro.isAvalista"
  [isValidatingClienteCpf]="isValidatingClienteCpf"
  [fichaCadastro]="fichaCadastro"
  [formulario]="formularioAvalista"
  [cpfCliente]="cpfCliente.value"
  [celularCliente]="celularCliente.value"
  (avalistaConjugeEmit)="onChangeAvalistaConjuge($event)"
>
</app-dados-avalista>

<app-dados-conjuge
  [hidden]="!fichaCadastro.isConjuge"
  [fichaCadastro]="fichaCadastro"
  [cpfCliente]="cpfCliente.value"
  (conjugeFormEmit)="onChangeFormConjuge($event)"
  (conjugeFormValidEmit)="formConjugeValid = $event"
>
</app-dados-conjuge>

<div class="row">
  <div class="marginT30 form-group tab-buttons">
    <a
      (click)="onClickPrevious()"
      class="bt-back btn btn-border-orange pull-left"
    >
      <i class="fa fa-arrow-left mrBt"></i> Voltar</a
    >
    <a
      class="bt-go btn btn-full-orange pull-right"
      [ngClass]="{
        disabled: validateNextButton(formCliente.valid, formConjugeValid)
      }"
      (click)="onClickNext()"
      >Continuar
      <i class="fa fa-arrow-right mlBt"></i>
    </a>
  </div>
</div>
<!-- Modal Seleção caso encontre ficha no CPF -->
<app-modal
  #modal
  title="ATENÇÃO"
  [ignoreBackdropClick]="true"
  [hideButtons]="true"
>
  <div class="modal-info">
    <h1>Existe uma ficha para esse CPF</h1>
    <h2>Você deseja</h2>
    <div class="buttons">
      <button
        (click)="recuperarFicha()"
        [disabled]="!showButtonRecuperaFicha"
        class="btn btn-full-orange"
      >
        Recuperar a ficha
      </button>
      <button (click)="recuperarDados()" class="btn btn-full-orange">
        Recuperar os dados
      </button>
      <button (click)="iniciarNovaFicha()" class="btn btn-full-orange">
        Iniciar nova ficha
      </button>
    </div>
  </div>
</app-modal>
